const DEFAULT_SITE_TITLE = 'Art Gobblers'
const DEFAULT_SITE_DESCRIPTION =
  'Art Gobblers - a digital art experiment by Justin Roiland and Paradigm'
const DEFAULT_SITE_NAME = 'Art Gobblers'

export { DEFAULT_SITE_TITLE, DEFAULT_SITE_DESCRIPTION, DEFAULT_SITE_NAME }
